<template>
  <v-container fluid fill-height>
    <v-img
      src="../assets/logo.png"
      alt="app logo"
      height="70px"
      width="70px"
      position="center center"
      contain
    ></v-img>
    <v-icon
      @click="$router.go(-1)"
      color="black"
      style="position: absolute; top: 50px; right: 50px"
      >mdi-close</v-icon
    >
    <v-row justify="center" align="center">
      <v-card flat width="300" class="pa-0 pb-16" style="overflow:hidden">
        <v-row justify="center" class="pt-5">
          <v-col v-if="errorMessage">{{ errorMessage }}</v-col>
          <v-col
            cols="auto"
            class="mr-8"
            id="firebaseui-auth-container"
          ></v-col>
          <v-col cols="auto">
            <v-btn @click="loginWithGoogle" class="theme--dark" color="primary">
              <v-img
                :src="require('../assets/google-icon.svg')"
                class="mr-1"
                style="width: 24px;"
              ></v-img>
              {{ $t("login_with_google") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { cfaSignIn } from "capacitor-firebase-auth";
import { auth, db } from "../../firebaseconfig";
import firebase from "firebase/app";
let firebaseui = require("firebaseui");
import "firebaseui/dist/firebaseui.css";
import { mapState, mapGetters } from "vuex";
const signInProviders = [
  firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
  // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  firebase.auth.EmailAuthProvider.PROVIDER_ID,
];
export default {
  name: "Login",
  data() {
    return {
      errorMessage: "",
    };
  },
  components: {},
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters({
      getUser: "getUser",
    }),
    showUI() {
      return this.$store.getters.getShowUI;
    },
  },
  methods: {
    mapUserToUserInfo() {
      console.log("signing in...");
    },
    async upgradeUsers(/*error*/) {
      // if (error.code !== "firebaseui/anonymous-upgrade-merge-conflict") {
      //   this.loading = false
      //   return Promise.resolve();
      // }

      let data = {};
      // let anonymousUser = auth.currentUser;
      this.errorMessage = this.$t('merging_templates');
      //todo: merge code
      // The credential the user tried to sign in with.
      // let cred = error.credential;
      // If using Firebase Realtime Database. The anonymous user data has to be
      // copied to the non-anonymous user.
      // Save anonymous user data first.
      await db
        .ref("users/" + auth.currentUser.uid + "/templates")
        .once("value")
        .then((snapshot) => {
          data = snapshot.val();
          // console.log(data);
          // return firebase.auth().signInWithCredential(cred);
        })
        // .then(async (userCred) => {
        //   // Original Anonymous Auth instance now has the new user.
        //   return db
        //       .ref("users/" + userCred.user.uid + "/templates")
        //       .update(data);
        // })
        .then(() => {
          // Delete anonymnous user.
          // return anonymousUser.delete();
        })
        .then(() => {
          // Clear data in case a new user signs in, and the state change
          // triggers.
          this.$store.commit("clearVuex");

          // data = null;
          // FirebaseUI will reset and the UI cleared when this promise
          // resolves.
          // signInSuccessWithAuthResult will not run. Successful sign-in
          // logic has to be run explicitly
          // .
          // window.location.assign("/");
        })
        .catch((error) => {
          // Delete anonymnous user.
          this.$toasted.show(error + this.$t("firebase_error_1"));
          // anonymousUser.delete().then(() => {
          //   // window.location.assign("/");
          // });
        });
      return data;
    },
    async signInWithFailed(error){

      if (error.code !== "firebaseui/anonymous-upgrade-merge-conflict") {
        this.loading = false
        return Promise.resolve();
      }

      let data = {};
      let anonymousUser = auth.currentUser;
      this.errorMessage = this.$t('merging_templates');
      //todo: merge code
      // The credential the user tried to sign in with.
      let cred = error.credential;
      // If using Firebase Realtime Database. The anonymous user data has to be
      // copied to the non-anonymous user.
      // Save anonymous user data first.
      return db
          .ref("users/" + auth.currentUser.uid + "/templates")
          .once("value")
          .then((snapshot) => {
            data = snapshot.val();
            return firebase.auth().signInWithCredential(cred);
          })
          .then(async (userCred) => {
            // Original Anonymous Auth instance now has the new user.
            return db
                .ref("users/" + userCred.user.uid + "/templates")
                .update(data);
          })
          .then(() => {
            // Delete anonymnous user.
            return anonymousUser.delete();
          })
          .then(() => {
            // Clear data in case a new user signs in, and the state change
            // triggers.
            this.$store.commit("clearVuex");

            data = null;
            // FirebaseUI will reset and the UI cleared when this promise
            // resolves.
            // signInSuccessWithAuthResult will not run. Successful sign-in
            // logic has to be run explicitly
            // .
            window.location.assign("/");
          })
          .catch((error) => {
            // Delete anonymnous user.
            this.$toasted.show(
                error + this.$t('firebase_error_1')
            );
            anonymousUser.delete().then(() => {
              window.location.assign("/");
            });
          });
    },
    saveUserProfile(authResult, data) {
      this.errorMessage = "Successfully signed in...";
      let user = authResult.user;

      db.ref("users")
        .child(user.uid)
        .child("createdOn")
        .get()
        .then((result) => {
          if (result.exists()) {
            console.log("old user");
          } else {
            console.log("new user");
            this.setupNewUser(user);
          }
        });

        db.ref("users")
        .child(user.uid)
        .child("subscription")
        .once('value').then(data=>{
          if(data.exists()){
            const sub=data.val();
            if(sub.type===1){
              this.$store.commit('setPremium',true)
            }else
            this.$store.commit('setPremium',false)
          }else{
            this.$store.commit('setPremium',false)
          }
        })
      // let isNewUser = authResult.additionalUserInfo.isNewUser;

      // Add starter template , createdOn, lastSignIn,
      // if (isNewUser) {
      //   this.setupNewUser(user);
      // } else {
      db.ref("users")
        .child(user.uid)
        .child("lastSignIn")
        .set(Date.now())
        .then();

      if (data) {
        db.ref("users/" + user.uid + "/templates").update(data);
      }
      // }
      this.$router.replace("/");
      //Use below code if async op has to be done after signin
      /* let s = async () => {
         let user = authResult.user;
         let isNewUser = authResult.additionalUserInfo.isNewUser;

         // Add starter template , createdOn, lastSignIn,
         if (isNewUser) {
           await this.setupNewUser(user);
         } else {
            db
                .ref("users")
                .child(user.uid)
                .child("lastSignIn")
                .set(Date.now()).then();
         }
         await this.$router.replace('/')
         // return false;
       };
       s();*/
    },
    async loginWithGoogle(evt) {
      let data = null;
      let anonymnousUser = null;
      evt.preventDefault();
      if (this.getUser&& this.getUser.isAnonymous) {
        console.log("anonymous user");
        data = await this.upgradeUsers();
        anonymnousUser = auth.currentUser;
      }
      cfaSignIn("google.com").subscribe((user) => {
        if (anonymnousUser) {
          anonymnousUser
            .delete()
            .then(() => {
              // User deleted.
            })
            .catch((error) => {
              // An error ocurred
              // ...
              console.log(error);
            });
        }
        this.saveUserProfile({ user }, data);
      });
      //  .catch(error=>{
      //    this.signInWithFailed(error)
      //  })

      // let provider =  new firebase.auth.GoogleAuthProvider();

      // // To apply the default browser preference instead of explicitly setting it.
      // firebase.auth().useDeviceLanguage();

      // firebase
      //     .auth()
      //     .signInWithPopup(provider)
      //     .then((authResult) =>{
      //       this. saveUserProfile(authResult)
      //     })
      //     .catch((error)=> {
      //       // Handle Errors here.
      //       let errorCode = error.code;
      //       let errorMessage = error.message;
      //       // The email of the user's account used.
      //       // let email = error.email;
      //       // The firebase.auth.AuthCredential type that was used.
      //       // let credential = error.credential;

      //       console.error("errorMessage - " + errorCode+ " : "+ errorMessage);
      //       // ...
      //     });
    },
    async setupNewUser(user) {
      // Add starter template , createdOn, lastSignIn,
      let starter = await db.ref("starter").once("value");
      let map = {
        ...starter.val(),
        email: user.email,
        createdOn: Date.now(),
        lastSignIn: Date.now(),
      };
      db.ref("users")
        .child(user.uid)
        .update(map)
        .then();
    },
  },
  mounted() {
    let ui =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

    let uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          this.saveUserProfile(authResult);
        },
        signInFailure: (error) => {
          this.signInWithFailed(error);
        },
      },

      autoUpgradeAnonymousUsers: true,
      signInOptions: this.user ? [signInProviders[1]] : signInProviders,
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  },
};
</script>

<style scoped></style>>
